import { FC, ReactNode, useState } from "react";
import { CurrentData, Expansion, GlobalSettings, Product } from "types";
import DataContext from "./data-context";

type DataContextProviderProps = {
  children: ReactNode;
};

export const DataContextProvider: FC<DataContextProviderProps> = ({
  children,
}) => {
  const [product, setProduct] = useState<Product | null>(null);
  const [expansion, setExpansion] = useState<Expansion | null>(null);
  const [globalSettings, setGlobalSettings] = useState<GlobalSettings | null>(
    null,
  );
  const [isLoadingStateEntities, setIsLoadingStateEntities] =
    useState<boolean>(false);
  const [isLoadingCurrentData, setIsLoadingCurrentData] =
    useState<boolean>(false);
  const [currentData, setCurrentData] = useState<CurrentData | null>(null);

  return (
    <DataContext.Provider
      value={{
        product,
        setProduct,
        expansion,
        setExpansion,
        globalSettings,
        setGlobalSettings,
        isLoadingStateEntities,
        setIsLoadingStateEntities,
        isLoadingCurrentData,
        setIsLoadingCurrentData,
        currentData,
        setCurrentData,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
